import { render, staticRenderFns } from "./QScoreCardALeads.vue?vue&type=template&id=0a546afb&scoped=true&"
import script from "./QScoreCardALeads.vue?vue&type=script&lang=js&"
export * from "./QScoreCardALeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a546afb",
  null
  
)

export default component.exports